// import "@babel/polyfill"
import Vue from 'vue'
import global_mixin from './global_mixins.js'
import LazyBackground from '../components/LazyBackground.vue'
import '../css/sustainability.css'
var _ = require('lodash')
import gql from 'graphql-tag'
Vue.component('lazy-background', LazyBackground)

const app = new Vue({
  el: '#app',
  components: {
  },
  mixins: [global_mixin],
  data() {
  },
  mounted() {},
  methods: {

  },
  computed: {
  },
  watch: {},
});



// WEBPACK FOOTER //
// ./core/vue/js/sustainability.js